import { cn } from "@/lib/utils";

interface DividerProps {
  label?: string;
  className?: string;
}

export function Divider({ label, className }: DividerProps) {
  const fullClassName = cn("flex-1 border-t border-gray-300", className);
  return (
    <>
      {label ? (
        <div className="flex items-center gap-4 my-4">
          <div className={fullClassName} />
          <span className="text-xs">{label}</span>
          <div className={fullClassName} />
        </div>
      ) : (
        <div className={fullClassName} />
      )}
    </>
  );
}
